module.exports = __webpack_public_path__ + "static/media/Atmo_factsheet.5fc35d28.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/download/files/Atmo_factsheet.pdf
// module id = 791
// module chunks = 0